// Import Dependencies
import { RouterProvider } from "react-router";

// Local Imports
import { AuthProvider } from "app/contexts/auth/Provider";
import { BreakpointProvider } from "app/contexts/breakpoint/Provider";
import { LocaleProvider } from "app/contexts/locale/Provider";
import { SidebarProvider } from "app/contexts/sidebar/Provider";
import { ThemeProvider } from "app/contexts/theme/Provider";
import { LoaderProvider } from "app/contexts/loader/Provider";
import { DocumentProvider } from "app/contexts/DocumentContext/Provider";
import { NotificationProvider } from "app/contexts/notification/Provider";
import { CallProvider } from "contexts/CallContext";
import { LeadDetailProvider } from "contexts/LeadDetailContext";
import router from "app/router/router";


// ----------------------------------------------------------------------

function App() {


  return (
    <AuthProvider>
      <ThemeProvider>
        <LocaleProvider>
          <BreakpointProvider>
            <SidebarProvider>
              <LoaderProvider>
                <NotificationProvider>
                  <DocumentProvider>
                    <LeadDetailProvider>
                      <CallProvider>
                        <RouterProvider router={router} />
                      </CallProvider>
                    </LeadDetailProvider>
                  </DocumentProvider>
                </NotificationProvider>
              </LoaderProvider>
            </SidebarProvider>
          </BreakpointProvider>
        </LocaleProvider>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;